module.exports = __webpack_public_path__ + "img/middle.fe855760.png";